<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">지출등록</span>
            <span class="txt">지출내역을 등록, 수정,관리할 수있습니다.</span>
        </div>

        <div class="com-search-content">
            <div class="line">
                <div class="com-calendar-wrap">
                    <single-calendar :start-date="startDate" @update="startDateUpdate"></single-calendar>
                    <div class="com-dash"><span class="dash">~</span></div>
                    <single-calendar :end-date="endDate" @update="endDateUpdate"></single-calendar>
                </div>
                <select-form
                    :select-data="['선택', ...periodTypeList]"
                    :select-value="['', ...periodTypeValueList]"
                    :selected-value="searchPeriod"
                    @update:set="(val) => (searchPeriod = val)"
                ></select-form>
                <div class="com-search-input">
                    <input
                        v-model="searchStr"
                        placeholder="이름, 연락처 입력"
                        type="text"
                        v-on:keyup.enter="onEventSearch"
                    />
                    <button class="search-btn" @click="onEventSearch">검색</button>
                </div>
            </div>
            <div class="line">
                <select-form
                    :select-data="['결제수단', '카드', '현금', '계좌이체', '마일리지', '기타']"
                    :select-value="['', 'C', 'L', 'B', 'M', 'E']"
                    :selected-value="payType"
                    @update:set="(val) => (payType = val)"
                ></select-form>
                <select-form
                    :select-data="['등록자', ...saleStaffList]"
                    :select-value="['', ...saleStaffValList]"
                    :selected-value="saleStaff"
                    class="w220"
                    @update:set="(val) => (saleStaff = val)"
                ></select-form>
                <select-form
                    :select-data="['영수증', '미발행', '현금', '세금']"
                    :select-value="['', 'N', 'R', 'C']"
                    :selected-value="receipt"
                    @update:set="(val) => (receipt = val)"
                ></select-form>
                <button class="com-search-reset" @click="resetSearchContent"></button>
            </div>
        </div>

        <div class="com-table-content">
            <div class="com-btn-area">
                <div class="right-box">
                    <router-link class="com-btn blue" to="/madmin/sales/expense/edit">지출 등록</router-link>
                    <router-link class="com-btn blue" to="/madmin/sales/expense/setting">설정</router-link>
                </div>
            </div>
            <table class="com-table">
                <colgroup>
                    <col style="width: 130px" />
                    <col style="width: 90px" />
                    <col style="width: 150px" />
                    <col style="width: 90px" />
                    <col style="width: 170px" />
                    <col style="width: 110px" />
                    <col style="width: 225px" />
                    <col style="width: 125px" />
                    <col style="width: 145px" />
                    <col style="width: 185px" />
                </colgroup>
                <thead>
                    <tr>
                        <th>
                            <button>결제일</button>
                        </th>
                        <th>
                            <button>지출구분</button>
                        </th>
                        <th>
                            <button>지출항목</button>
                        </th>
                        <th>
                            <button>수량</button>
                        </th>
                        <th>
                            <button>결제정보</button>
                        </th>
                        <th>
                            <button>영수증</button>
                        </th>
                        <th>메모</th>
                        <th>
                            <button>등록자</button>
                        </th>
                        <th>
                            <button>등록일</button>
                        </th>
                        <th>관리</th>
                    </tr>
                </thead>
                <tbody>
                    <!-- <tr>
                    <td>2019-12-25</td>
                    <td>고정</td>
                    <td>임대료</td>
                    <td>1</td>
                    <td>계좌 300,000원</td>
                    <td>미발행</td>
                    <td>세금계산서 나중에 발행</td>
                    <td>김윤경</td>
                    <td>2020-01-01 16:45</td>
                    <td>
                        <button class="com-btn blue">수정</button>
                        <button class="com-btn red">삭제</button>
                    </td>
                </tr> -->
                    <tr v-for="e in expenseList" :key="e.b_center_bill_id">
                        <td>{{ e.b_time_dt | timestampFilter }}</td>
                        <td>{{ convertExp(e.b_exp_type_cd) }}</td>
                        <td>{{ e.b_exp_item }}</td>
                        <td>{{ e.b_exp_cnt }}</td>
                        <td>{{ convertType(e.b_bill_pay_type_cd) }} {{ e.b_bill_price | numberFormatFilter }}원</td>
                        <td>{{ recpType(e.b_bill_recp_type_cd) }}</td>
                        <td>{{ e.b_memo }}</td>
                        <!--메모값 수정 필요-->
                        <td>{{ e.b_bill_reg_staff_nm }}</td>
                        <td>{{ e.b_cre_dt | timestampFilter2 }}</td>
                        <td>
                            <router-link
                                :to="{ path: `/madmin/sales/expense/edit`, query: { billId: e.b_center_bill_id } }"
                                class="com-btn blue"
                            >
                                수정
                            </router-link>
                            <button class="com-btn red" @click="deleteExpenseItem(e.b_center_bill_id)">삭제</button>
                        </td>
                    </tr>
                    <tr v-if="expenseList.length === 0">
                        <td colspan="100">등록된 내용이 없습니다.</td>
                    </tr>
                </tbody>
            </table>
            <div class="sort-bottom-area">
                <button class="com-btn excel" @click="excelDownload">엑셀 다운로드</button>
                <select-form
                    :select-data="[...sortTypeList]"
                    :select-value="[...sortTypeValueList]"
                    class="float-right"
                    @update:set="changeLimit"
                ></select-form>
            </div>
            <b-pagination
                v-model="pagingInfo.page"
                :per-page="pagingInfo.limit"
                :total-rows="pagingInfo.totalItems"
                align="center"
                aria-controls="my-table"
                first-class="first"
                last-class="last"
                next-class="next"
                prev-class="prev"
                @change="handlerPagenation($event)"
            ></b-pagination>
        </div>
    </div>
</template>

<script>
import api from '@/assets/js/api';
import moment from 'moment';
import EventBus from '../../../assets/js/eventBus';
import XLSX from 'xlsx';
import { dateFormatFilter, numberFormat, timestampToDate } from '@/assets/js/excelCommon.js';
import { MixinAllowedMenu } from '@/assets/js/mixinAllowedMenu';
import { pagingInfo } from '@/assets/js/common';
export default {
    name: 'SalesExpense',
    mixins: [MixinAllowedMenu],
    props: {},
    computed: {
        cId() {
            const { getters } = this.$store;
            return getters['auth/cId'];
        },
    },
    watch: {
        searchPeriod(newValue) {
            // 검색 기간 설정 변수
            this.searchPeriod = newValue;

            if (newValue === 'today') {
                // 오늘
                this.startDate = moment().format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === 'yesterday') {
                // 어제
                this.startDate = moment().subtract(1, 'days').format('YYYY-MM-DD');
                this.endDate = moment().subtract(1, 'days').format('YYYY-MM-DD');
            } else if (newValue === 'thisMonth') {
                // 이번 달
                this.startDate = moment().startOf('month').format('YYYY-MM-DD');
                this.endDate = moment().endOf('month').format('YYYY-MM-DD');
            } else if (newValue === 'prevMonth') {
                // 지난 달
                this.startDate = moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD');
                this.endDate = moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD');
            } else if (newValue === '3M') {
                // 3개월
                this.startDate = moment().subtract(3, 'months').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === '6M') {
                // 6개월
                this.startDate = moment().subtract(6, 'months').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === '12M') {
                // 12개월
                this.startDate = moment().subtract(12, 'months').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === '') {
                this.initStartDate();
                this.initEndDate();
            }
            this.onSearchList();
        },
        startDate(newValue) {
            // 검색 시작일
            this.startDate = newValue;
        },
        endDate(newValue) {
            // 검색 종료일
            this.endDate = newValue;
        },
        payType(newValue) {
            this.payType = newValue;
            this.onSearchList();
        },
        receipt(newValue) {
            this.receipt = newValue;
        },
        saleStaff(newValue) {
            this.saleStaff = newValue;
            this.onSearchList();
        },
    },
    data() {
        return {
            centerId: '',

            startDate: '',
            endDate: '',
            expenseList: [],

            sortTypeList: [...this.$sortType],
            sortTypeValueList: [...this.$sortTypeValue],
            pagingInfo: { ...pagingInfo },

            periodTypeList: [...this.$periodTypeList],
            periodTypeValueList: [...this.$periodTypeValueList],

            searchStr: '', // 이름, 연락처 검색 파라미터
            searchPeriod: 'thisMonth', // 검색 기간 설정
            payType: '',
            receipt: '',

            saleStaff: '',
            saleStaffList: [],
            saleStaffValList: [],

            count: 1,
        };
    },
    mounted() {
        this.goMainIfNotAllowed('SA', 4);

        this.centerId = this.cId; // 센터 Id
        this.init();
    },
    methods: {
        // 초기화
        init() {
            this.pagingInfo.page = 1;
            this.pagingInfo.limit = 10;
            this.initStartDate(); // 검색 시작일 초기화
            this.initEndDate(); // 검색 종료일 초기화
            Promise.allSettled([this.onSearchList(), this.onStaffList()]);
            // 리스트 불러오기
            // 스태프 리스트
        },
        async excelDownload() {
            // 엑셀 다운로드 기능구현
            const { data } = await this.getSearchListExcel(); // 엑셀용 요청값

            const excelDownloadArray = [];
            data.items.forEach((e) => {
                const temp = {};
                temp['결제일'] = timestampToDate(e.b_time_dt);
                temp['지출구분'] = this.convertExp(e.b_exp_type_cd);
                temp['지출항목'] = e.b_exp_item;
                temp['수량'] = e.b_exp_cnt;
                temp['결제정보'] = this.convertType(e.b_bill_pay_type_cd) + numberFormat(e.b_bill_price);
                temp['영수증'] = this.recpType(e.b_bill_recp_type_cd);
                temp['메모'] = e.b_memo;
                temp['등록자'] = e.b_bill_reg_staff_nm;
                temp['등록일'] = dateFormatFilter(e.b_cre_dt);

                excelDownloadArray.push(temp);
            });
            /* [Key:value,...] */
            const dataWS = XLSX.utils.json_to_sheet(excelDownloadArray); // 배열을 넣어야함.
            // cell width 설정
            const wscols = [
                { wch: 12 },
                { wch: 12 },
                { wch: 20 },
                { wch: 15 },
                { wch: 10 },
                { wch: 25 },
                { wch: 15 },
                { wch: 20 },
                { wch: 25 },
            ];
            dataWS['!cols'] = wscols;

            // cell height 설정
            const wsrows = [{ hpx: 30 }];
            dataWS['!rows'] = wsrows;
            const wb = XLSX.utils.book_new();

            XLSX.utils.book_append_sheet(wb, dataWS, '지출등록');
            XLSX.writeFile(wb, '지출등록.xlsx');
        },
        // 엑셀 다운로드를 위한 리스트
        getSearchListExcel() {
            return api.get(`/admin/api/centerBill/expense/all/${this.centerId}`, {
                params: {
                    searchStartDate: moment(this.startDate).format('YYYYMMDD'),
                    searchEndDate: moment(this.endDate).format('YYYYMMDD'),
                    billingPayType: this.payType, // 결제타입
                    billingReceiptType: this.receipt, // 영수증
                    billingRegistStaffId: this.saleStaff, // 등록자아이디
                    sortType: 'ASC', // 정렬타입
                    page: 1,
                    limit: 10000,
                },
            });
        },

        async onSearchList() {
            try {
                const { data } = await this.getSearchList();
                this.setPageParams(data);
                console.log('지출관련 데이터 리스트', data);
                this.expenseList = data.items;
            } catch (error) {
                console.log(error);
                console.log('error');
            }
        },
        getSearchList() {
            // 스웨거 검색: 센터 지출금액 목록조회(페이징)
            return api.get(`/admin/api/centerBill/expense/all/${this.centerId}`, {
                params: {
                    searchStartDate: moment(this.startDate).format('YYYYMMDD'),
                    searchEndDate: moment(this.endDate).format('YYYYMMDD'),
                    billingPayType: this.payType, // 결제타입
                    billingReceiptType: this.receipt, // 영수증
                    billingRegistStaffId: this.saleStaff, // 등록자아이디
                    sortType: 'ASC', // 정렬타입
                    ...this.pagingInfo,
                },
            });
        },
        // 한 페이지에 표시되는 줄 수 변경
        changeLimit(val) {
            this.pagingInfo.limit = val;
            this.onSearchList();
        },

        // 페이징 이벤트
        handlerPagenation(event) {
            this.pagingInfo.page = event;
            this.onSearchList();
        },

        // 검색 시작일 초기화
        initStartDate() {
            const startDate = moment().startOf('month').format('YYYY-MM-DD');
            this.startDate = startDate;
        },

        // 검색 종료일 초기화
        initEndDate() {
            const endDate = moment().endOf('month').format('YYYY-MM-DD');
            this.endDate = endDate;
        },

        // 검색 시작일 변경 event
        startDateUpdate(val) {
            this.startDate = val;
            this.onSearchList();
        },

        // 검색 종료일 변경 event
        endDateUpdate(val) {
            this.endDate = val;
            this.onSearchList();
        },
        // 회원 목록 키워드 검색 이벤트
        onEventSearch(e) {
            if (this.searchStr.length > 0 && this.searchStr.length < 2) {
                return;
            }
            this.onSearchList();
        },
        // 페이징 Param 설정
        setPageParams(data) {
            this.pagingInfo.totalPages = data.meta.totalPages;
            this.pagingInfo.page = data.meta.currentPage;
            this.pagingInfo.totalItems = data.meta.totalItems;
            this.pagingInfo.itemCount = data.meta.itemCount;
        },
        convertType(type) {
            if (type == 'C') {
                return '카드';
            } else if (type == 'L') {
                return '현금';
            } else if (type == 'B') {
                return '계좌이체';
            } else if (type == 'M') {
                return '마일리지';
            } else if (type == 'E') {
                return '기타';
            }
        },
        recpType(type) {
            if (type == 'N') {
                return '미발행';
            } else if (type == 'T') {
                return '세금계산서';
            } else if (type == 'C') {
                return '현금영수증';
            }
        },
        // 삭제 기능 구현
        async deleteExpenseItem(val) {
            try {
                console.log(val);
                const { data } = await this.deleteOnExpenseItem(val);
                // 삭제완료되면 재 리스팅
                this.onSearchList();
            } catch (error) {
                console.log(error);
                console.log('error');
            }
        },
        deleteOnExpenseItem(val) {
            return api.delete(`/admin/api/centerBill/delete/${this.centerId}/${val}`);
        },
        convertExp(type) {
            if (type == 'C') {
                return '변동';
            } else if (type == 'F') {
                return '고정';
            }
        },
        // 직원목록 가져오기
        async onStaffList() {
            try {
                const { data } = await this.getStaffList();
                data.sort(
                    (
                        a,
                        b // order by 정렬
                    ) => (a.name < b.name ? -1 : a.name > b.name ? 1 : 0)
                );
                console.log('직원목록', data);
                data.forEach((g) => {
                    this.saleStaffList.push(g.name);
                    this.saleStaffValList.push(g.centerStaffId);
                });
            } catch (error) {
                console.log('error');
                console.log(error);
            }
        },
        getStaffList() {
            return api.get(`/admin/api/center/${this.centerId}/staff/teachers/list`);
        },
        // 검색 조건 초기화
        resetSearchContent() {
            this.startDate = this.initStartDate();
            this.endDate = this.initEndDate();
            (this.payType = ''), (this.receipt = '');
            this.saleStaff = '';
            this.onSearchList();
            EventBus.$emit('event:init', 'init');
        },
    },
};
</script>
<style lang="scss"></style>
